import { TextureLoader } from "three";

class Data {
  constructor() {}
  async load({ attributionUrl, dataUrl, thumbnails_url, mask_url }) {
    let offensive;
    let attribution;

    return new Promise(async (resolve, reject) => {
      await fetch(attributionUrl)
        .then((res) => res.json())
        .then((json) => {
          offensive = json.offensive;
          attribution = json.partners;
        });
      fetch(dataUrl)
        .then((res) => res.json())
        .then((json) => {
          const items = [];
          // we don't keep the offensive items
          json.items.forEach((item, i) => {
            item.offensive = offensive.indexOf(item.id) != -1;
            item.attribution = attribution[i];
            item.uvId = i;
            if (!item.offensive) items.push(item);
          });

          //preload the texture for immediate display
          let tl = new TextureLoader();
          tl.load(thumbnails_url, (texture) => {
            //load the mask texture
            tl.load(mask_url, (mask) => {
              // we resolve the promise with what we need
              resolve({
                labels: json.labels,
                items,
                texture,
                mask,
              });
            });
          });
        });
    });
  }
}
export const data = new Data();
